import { FC } from 'react';
import { Spin, SpinProps } from 'antd';

const Spinner: FC<SpinProps> = (props) => {
  return <Spin {...props} />;
};

export default Spinner;
